module.exports = __webpack_public_path__ + "img/ep-2.c1bae4b1.jpg";